import posthog from 'posthog-js';

// Initialize PostHog only if API key is provided
const POSTHOG_API_KEY = process.env.REACT_APP_POSTHOG_API_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com';

let isInitialized = false;

export const initPostHog = () => {
  if (isInitialized || !POSTHOG_API_KEY) {
    return;
  }
  
  posthog.init(POSTHOG_API_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: false,
    capture_pageleave: false,
    autocapture: false,
    disable_session_recording: true,
  });
  
  isInitialized = true;
};

// Identify user after login/signup
export const identifyUser = (userId, email) => {
  if (!POSTHOG_API_KEY || !isInitialized) return;
  
  posthog.identify(userId, {
    email: email,
  });
};

// Reset user on logout
export const resetUser = () => {
  if (!POSTHOG_API_KEY || !isInitialized) return;
  
  posthog.reset();
};

// Track specific events only
export const trackEvent = (eventName, properties = {}) => {
  if (!POSTHOG_API_KEY || !isInitialized) return;
  
  // Only allow specific events
  const allowedEvents = [
    'user_signed_up',
    'user_logged_in',
    'project_created',
    'plan_generated',
    'prompt_update_submitted',
    'exec_brief_generated',
  ];
  
  if (!allowedEvents.includes(eventName)) {
    return;
  }
  
  posthog.capture(eventName, properties);
};

export default posthog;
